import { renderPlot } from "../../../plot/Utils.js";

// static plot container
let currentPlot = null;
let plotInterval = null;
let plotTimeout = null;

function clearTimers() {
    if (plotInterval) clearInterval(plotInterval);
    if (plotTimeout) clearTimeout(plotTimeout);
    plotInterval = null;
    plotTimeout = null;
}

function plot(queue, id, labelX, labelY, data, invertXAxis, invertYAxis, hoverY) {
    queue.push(container => {
        clearTimers();

        const target = container.querySelector("." + id);

        const createPlot = () => {
            clearTimers();
            if (currentPlot) Plotly.purge(currentPlot);
            currentPlot = renderPlot(target, labelX, labelY, data, invertXAxis, invertYAxis, hoverY);
        };

        // only init plot if the target is visible in DOM (offsetParent == null if not displayed)
        // use timeout to push to end of eventloop. If not in DOM check repeatedly
        plotTimeout = setTimeout(() => {
            if (target.offsetParent) {
                createPlot()
            } else {
                plotInterval = setInterval(() => {
                    if (target.offsetParent) createPlot();
                }, 700);
            }
        }, 50);
    });
}

/**
 * Helper method to parse the values from the string into an array
 * @private
 */
function getValues(input, isString) {
    if (!input) return null;
    const values = input.slice(1, -1).split(",");
    for (let i = 0; i < values.length; ++i) {
        if (isString) {
            values[i] = values[i].slice(1, -1);
        } else {
            values[i] = parseFloat(values[i]);
        }
    }
    return values
}

/**
 * Creates an overview plot for the measurements layers
 * 
 * @param {string[]} args unused
 * @param {object} data response
 * @returns {string} span placeholder
 * @memberof vef.map.popup.templateFunctions
 */
export function marehubOverviewPlot(myArgs, data, postProcessingQueue) {
    const properties = data.properties;

    if (properties.ov_type && (properties.value_cnt > 1)) {
        const id = `marehubOverviewPlot_${postProcessingQueue.length}`;
        const div = `<div class="${id}" style="width:100%;"></div>`;

        const times = getValues(properties.times, true);
        const depths = getValues(properties.depths);
        const values = getValues(properties.values);

        if (values) {
            // create regular plots
            switch (properties.ov_type) {
                case "depth profile, stationary":
                    if (depths && (depths.length > 0)) {
                        const labelX = properties.parameter_name + ((properties.parameter_unit) ? ` [${properties.parameter_unit}]` : '');
                        const labelY = (properties.depth_type || "depth") + " [m]";
                        plot(postProcessingQueue, id, labelX, labelY, [{ x: values, y: depths }], false, true, true);
                        return div;
                    }
                    break;
                case "time series, stationary":
                case "time series, moving":
                    if (times && (times.length > 0)) {
                        const labelX = "Time of Day";
                        const labelY = properties.parameter_name + ((properties.parameter_unit) ? ` [${properties.parameter_unit}]` : '');
                        plot(postProcessingQueue, id, labelX, labelY, [{ x: times, y: values }], false, false);
                        return div;
                    }
                    break;
            }
        } else {
            // special case for current
            const values_vc = getValues(properties.values_vc);
            const values_uc = getValues(properties.values_uc);

            if (!values_vc || !values_uc) return undefined;

            switch (properties.ov_type) {
                case "depth profile, stationary":
                    if (depths && (depths.length > 0)) {
                        const labelX = "Current Velocity" + ((properties.parameter_unit) ? ` [${properties.parameter_unit}]` : '');
                        const labelY = (properties.depth_type || "depth") + " [m]";
                        const data = [
                            { x: values_vc, y: depths, name: "VC" },
                            { x: values_uc, y: depths, name: "UC" }
                        ]
                        plot(postProcessingQueue, id, labelX, labelY, data, false, true, true);
                        return div;
                    }
                    break;
                case "time series, stationary":
                case "time series, moving":
                    if (times && (times.length > 0)) {
                        const labelX = "Time of Day";
                        const labelY = "Current Velocity" + ((properties.parameter_unit) ? ` [${properties.parameter_unit}]` : '');
                        const data = [
                            { y: values_vc, x: times, name: "VC" },
                            { y: values_uc, x: times, name: "UC" }
                        ]
                        plot(postProcessingQueue, id, labelX, labelY, data, false, false);
                        return div;
                    }
                    break;
            }
        }

    }

    return undefined;
}

/**
 * Prints the value with unit if only one value exists
 * 
 * @param {string[]} myArgs column, unit
 * @param {object} data response
 * @returns {string} depth
 * @memberof vef.map.popup.templateFunctions
 */
export function getMarehubOverviewValue(myArgs, data, postProcessingQueue) {
    const properties = data.properties;

    const column = (myArgs.length > 0) ? myArgs[0] : "values";
    const unit = (myArgs.length > 1) ? myArgs[1] : properties.parameter_unit;

    if (properties.value_cnt == 1) {
        const values = getValues(properties[column]);
        if (values.length == 1) {
            let value = values[0];
            if (unit) value += " " + unit;
            return value
        }
    }

    return undefined;
}